import {
  loginReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  creatUserReducer,
  confirmEmailReducer,
  activateAccountWithCodeReducer,
  requestAccountActivationCodeReducer,
  resendActivationEmailReducer,
  confirmAccountPhoneReducer,
  getOtpForVendorPhoneReducer,
  getUrlReducer,
  getStoreCatsReducer,
  uploadStoreLogoReducer,
} from "../reducers/onboarding/outbound.reducer";

import {
  getImageGalleryReducer,
  getStoreOrderReducer,
  getStoreOrderDetailsReducer,
  createStorePayoutReducer,
  linkExternalAccountReducer,
  getStorePayoutAccReducer,
  getStoreDetailsReducer,
  updateStoreDetailsReducer,
  getDashbardTopDataReducer,
  getDashbardMiddleDataReducer,
  getDashbardBottompDataReducer,
  createPayoutInfoTokenReducer,
  deactivatePayoutAccountReducer,
  getPayoutPendingLinkReducer,
  getStorePaymentsHistoryReducer,
  changeOrderStatusReducer,
  addNewStoreReducer,
  addAStaffReducer,
  deleteAStaffReducer,
  getAllStaffReducer,
  lightspeedStartOAuthReducer,
  lightspeedHandleCallbackReducer,
  lightspeedCheckConnectionReducer,
  lightspeedDisconnectReducer,
  lightspeedCheckInstallationReducer,

} from "../reducers/inapp/inapp.reducer";

import {
  createStoreProductReducer,
  uploadStoreBulkProductsReducer,
  bulkProductUpdateReducer,
  getAProductReducer,
  getProductListReducer,
  getProductMetaDataReducer,
  getAttributeTemplatesReducer,
  getAttributeTemplateDetailReducer,
  updateProductImageReducer,
  updateStoreProductReducer,
  toggleProductReducer,
  deleteStoreProductReducer
} from "./inapp/Products/product.reducer";

import { getOrderShipmentLabelReducer } from "./inapp/Orders/order.reducer";

export const inAppReducers = {
  createStoreProductReducer,
  uploadStoreBulkProductsReducer,
  updateStoreProductReducer,
  bulkProductUpdateReducer,
  getProductMetaDataReducer,
  getAttributeTemplatesReducer,
  getAttributeTemplateDetailReducer,
  getImageGalleryReducer,
  getProductListReducer,
  toggleProductReducer,
  getAProductReducer,
  updateProductImageReducer,
  deleteStoreProductReducer,
  getStoreOrderReducer,
  getStoreOrderDetailsReducer,
  createStorePayoutReducer,
  linkExternalAccountReducer,
  getStorePayoutAccReducer,
  getStoreDetailsReducer,
  updateStoreDetailsReducer,
  getDashbardTopDataReducer,
  getDashbardMiddleDataReducer,
  getDashbardBottompDataReducer,

  createPayoutInfoTokenReducer,
  deactivatePayoutAccountReducer,
  getPayoutPendingLinkReducer,
  getStorePaymentsHistoryReducer,

  changeOrderStatusReducer,
  getOrderShipmentLabelReducer,

  addNewStoreReducer,
  addAStaffReducer,
  deleteAStaffReducer,
  getAllStaffReducer,

  // Lightspeed Integration Reducers
  lightspeedStartOAuthReducer,
  lightspeedHandleCallbackReducer,
  lightspeedCheckConnectionReducer,
  lightspeedDisconnectReducer,
  lightspeedCheckInstallationReducer,
};

export const outboundReducers = {
  loginReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  creatUserReducer,
  confirmEmailReducer,
  activateAccountWithCodeReducer,
  requestAccountActivationCodeReducer,
  resendActivationEmailReducer,
  confirmAccountPhoneReducer,
  getOtpForVendorPhoneReducer,
  getUrlReducer,
  getStoreCatsReducer,
  uploadStoreLogoReducer,
};
